import React from "react";
import {
    withStyles
} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import {Typography, IconButton} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {Dialog} from "@material-ui/core";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import Box from "../../lib/appfuse-react/component/Box";
import Expander from "../../lib/appfuse-react/component/Expander";
import PropTypes from "prop-types";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    container: {
        padding: theme.spacing(2,2,1,2)
    },
});

export const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, subtitle, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Box display="flex" flexDirection="column">
                <Box display="flex" alignItems="flex-start">
                    <Typography variant="h6" >{children}</Typography>
                    <Expander/>
                    {onClose ? (
                        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} size="small">
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </Box>
                { subtitle && <Typography variant="subtitle1" color="textSecondary">{subtitle}</Typography>}
            </Box>
        </MuiDialogTitle>
    );
});

export const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

export const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

export const StyledDialog = withStyles(theme => ({
    paperWidthSm: {
        maxWidth: '70%',
        minWidth: "50%"
    },
    paperScrollPaper: {
        display: 'flex',
        maxHeight: 'calc(100% - 128px)',
        flexDirection: 'column'
    },
    paper: {
        borderRadius: '1rem'
    },
}))(Dialog);

const useStyles = makeStyles(theme => ({
    paper: {
        width: props => props.width,
        minWidth: props => props.minWidth,
        maxWidth: props => props.maxWidth,
        height: props => props.height,
        minHeight: props => props.minHeight,
        maxHeight: props => props.maxHeight,
        borderRadius: props => props.borderRadius
    },
    paperScrollPaper: {
        display: 'flex',
        maxHeight: 'calc(100% - 128px)',
        flexDirection: 'column'
    },
}))

export const StyleDialog = React.forwardRef((props, ref) => {
    const { children, open, width, minWidth, maxWidth, height, minHeight, maxHeight, borderRadius } = props;
    const classes = useStyles({width, minWidth, maxWidth, height, minHeight, maxHeight, borderRadius});

    return (
        <Dialog
            open={open}
            classes={{paper: classes.paper, paperScrollPaper: classes.paperScrollPaper}}
        >
            {children}
        </Dialog>
    )
})

StyleDialog.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.array
    ]),
    open: PropTypes.bool,

    // Border
    borderRadius: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),

    // Sizing
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    maxWidth: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    minWidth: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    height: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    maxHeight: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    minHeight: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
}

StyleDialog.defaultProps = {
    borderRadius: '1rem',
    width: '60vw',
    maxWidth: '100%'
}
